import(/* webpackMode: "eager" */ "/vercel/path0/apps/dine-rewards/src/components/views/LoadingPage/LoadingPage.module.scss");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/image-component.js");
